import ConsoleTemplate from '../_shoru_shared_library/template/ConsoleTemplate';
import AppBar from '../components/AppBar';
import adminConsoleRouter from './adminConsoleRouter';

function AdminConsole() {
  
  return (

    <ConsoleTemplate 
      admin
      appBar={<AppBar />}
      router={adminConsoleRouter} 
      accentColour='#0984e3'
      appName='castingbot'
      consoleName='admin-console'
    />

  )

}

export default AdminConsole;